// extracted by mini-css-extract-plugin
export default {"cart-items":"cart_cart-items__wBRtr","total":"cart_total__Tn7Bv","actions":"cart_actions__Tu5xl","button--alt":"cart_button--alt__wOa4Q","button":"cart_button__1svTP"};